import type { TransformedPrice } from '~/services/transformations/art-listing-results'
import { formatPrice } from '~/services/transformations/formatters/price'

export function formatEstimatedPrices({
    price,
    showEstPrefix,
    showDollarSign,
    currencyCode,
    locale,
}: {
    price: TransformedPrice['price']
    showEstPrefix: boolean
    // Whether to show a dollar sign in front of the price.
    // Only set this to true if the price is in a currency that should have a dollar sign.
    showDollarSign: boolean
    currencyCode: string
    locale?: string
}) {
    const optionalDollarSign = showDollarSign ? '$' : ''
    const lowPrice =
        price.estimatedPriceLow &&
        formatPrice(price.estimatedPriceLow, currencyCode, locale, false)
    const highPrice =
        price.estimatedPriceHigh &&
        formatPrice(price.estimatedPriceHigh, currencyCode, locale, false)
    const low = lowPrice ? optionalDollarSign + lowPrice : ''
    const high = highPrice ? optionalDollarSign + highPrice : ''

    if (low && high) {
        const range = low === high ? low : `${low} - ${high}`
        return `${showEstPrefix ? 'Est. ' : ''}${range}`
    } else if (low) {
        return showEstPrefix ? `Low est. ${low}` : low
    } else if (high) {
        // note: we aren't displaying the price if not showing the prefix
        return showEstPrefix ? `High est. ${high}` : ''
    } else {
        return ''
    }
}
